import { render, staticRenderFns } from "./ArchiveBase.vue?vue&type=template&id=485b0baf&scoped=true&lang=pug&"
import script from "./ArchiveBase.vue?vue&type=script&lang=js&"
export * from "./ArchiveBase.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveBase.scss?vue&type=style&index=0&id=485b0baf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485b0baf",
  null
  
)

export default component.exports